import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameCityImprovementProgressTrackerSquareView} from './UIGameCityImprovementProgressTrackerSquareView'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {CityImprovementTypes} from '@colonist/game-states'

export class UIGameCityImprovementProgressTrackerView extends SectionView {
    currentCityImprovementLevel: number | undefined
    readonly cityImprovementType: CityImprovementTypes
    private readonly progressSquareViews: UIGameCityImprovementProgressTrackerSquareView[]
    private readonly metropolisIconView: SpriteView

    private readonly overlapBetweenSquares: number
    private readonly maxCityImprovementLevel: number

    constructor(x: number, y: number, w: number, container: PIXI.Container, cityImprovementType: CityImprovementTypes) {
        const overlapBetweenSquares = 1
        const maxCityImprovementLevel = 5

        const h = w + w * (maxCityImprovementLevel) * overlapBetweenSquares
        super(x, y, w, h, container, true)
        this.cityImprovementType = cityImprovementType

        const metropolisTexture = this.getMetropolisIconTextureForCityImprovementType()
        const padding = this.width * 0.05
        this.metropolisIconView = new SpriteView(0, 0, this.width, this.width, this, metropolisTexture, padding)
        this.hideMetropolisIcon()

        this.overlapBetweenSquares = overlapBetweenSquares
        this.maxCityImprovementLevel = maxCityImprovementLevel

        this.progressSquareViews = []
        this.initProgressSquareViews()
    }

    private initProgressSquareViews() {
        const squareHeight = this.width
        const squareSpacing = squareHeight * this.overlapBetweenSquares
        let squareY = squareSpacing
        for(let cityProgressLevel = this.maxCityImprovementLevel; cityProgressLevel > 0; cityProgressLevel--) {
            const newSquareView = new UIGameCityImprovementProgressTrackerSquareView(0, squareY, squareHeight, this, this.cityImprovementType, cityProgressLevel)
            this.progressSquareViews.push(newSquareView)

            squareY += squareSpacing
        }
    }

    updateProgressTracker(newLevel: number) {
        this.currentCityImprovementLevel = newLevel
        for(const progressSquareView of this.progressSquareViews) {
            progressSquareView.progressLevel > newLevel ? progressSquareView.setInactiveTexture() : progressSquareView.setActiveTexture()
        }
    }

    showMetropolisIcon() {
        if(this.metropolisIconView.parent != undefined) return
        this.addChild(this.metropolisIconView)
    }

    hideMetropolisIcon() {
        if(this.metropolisIconView.parent == undefined) return
        this.metropolisIconView.parent.removeChild(this.metropolisIconView)
    }

    private getMetropolisIconTextureForCityImprovementType(): PIXI.Texture {
        switch(this.cityImprovementType) {
            case CityImprovementTypes.Politics: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_triangle_politics)
            case CityImprovementTypes.Science: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_triangle_science)
            case CityImprovementTypes.Trade: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_triangle_trade)
        }
    }
}
